/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputWeatherRun
 */
export interface OutputWeatherRun {
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherRun
     */
    apiWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherRun
     */
    durationSec?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputWeatherRun
     */
    error?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputWeatherRun
     */
    finishedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherRun
     */
    gridPoints?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherRun
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputWeatherRun
     */
    kind?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherRun
     */
    requests?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherRun
     */
    samples?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputWeatherRun
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputWeatherRun
     */
    status?: string;
}

/**
 * Check if a given object implements the OutputWeatherRun interface.
 */
export function instanceOfOutputWeatherRun(value: object): boolean {
    return true;
}

export function OutputWeatherRunFromJSON(json: any): OutputWeatherRun {
    return OutputWeatherRunFromJSONTyped(json, false);
}

export function OutputWeatherRunFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWeatherRun {
    if (json == null) {
        return json;
    }
    return {
        
        'apiWeight': json['apiWeight'] == null ? undefined : json['apiWeight'],
        'durationSec': json['durationSec'] == null ? undefined : json['durationSec'],
        'error': json['error'] == null ? undefined : json['error'],
        'finishedAt': json['finishedAt'] == null ? undefined : json['finishedAt'],
        'gridPoints': json['gridPoints'] == null ? undefined : json['gridPoints'],
        'id': json['id'] == null ? undefined : json['id'],
        'kind': json['kind'] == null ? undefined : json['kind'],
        'requests': json['requests'] == null ? undefined : json['requests'],
        'samples': json['samples'] == null ? undefined : json['samples'],
        'startedAt': json['startedAt'] == null ? undefined : json['startedAt'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function OutputWeatherRunToJSON(value?: OutputWeatherRun | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'apiWeight': value['apiWeight'],
        'durationSec': value['durationSec'],
        'error': value['error'],
        'finishedAt': value['finishedAt'],
        'gridPoints': value['gridPoints'],
        'id': value['id'],
        'kind': value['kind'],
        'requests': value['requests'],
        'samples': value['samples'],
        'startedAt': value['startedAt'],
        'status': value['status'],
    };
}

